import React from 'react';
import './_changeLog.scss';
import ChangeLogSection from './ChangeLogSection';
import { useSelector } from 'react-redux';

const ChangeLogContent = ({ onClose }) => {
  const { list } = useSelector((state) => state.changelog);

  return (
    <div className="change-log-content-container">
      {list.map((sectionInfo, index) => (
        <ChangeLogSection sectionInfo={sectionInfo} onClose={onClose} key={sectionInfo._id} index={index} />
      ))}
    </div>
  );
};

export default ChangeLogContent;
